export class Clock {
  static readonly startTime: number = window.$mediavine.web.startTime

  static getTime(): number {
    return Date.now() - this.startTime
  }
}
